import {
  BusStopGridCell,
  BusStopGridHeader,
} from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopGrid";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/Spor";

export const BusStopHeader: FC = () => {
  const { t } = useTranslation();
  return (
    <BusStopGridHeader role="row">
      <BusStopGridCell role="columnheader" />
      <BusStopGridCell role="columnheader">
        <Text variant="sm" fontWeight={400}>
          {t("Holdeplass")}
        </Text>
      </BusStopGridCell>
      <BusStopGridCell role="columnheader">
        <Text variant="sm" fontWeight={400}>
          {t("Ankomst")}
        </Text>
      </BusStopGridCell>
      <BusStopGridCell role="columnheader">
        <Text variant="sm" fontWeight={400}>
          {t("Avgang")}
        </Text>
      </BusStopGridCell>
    </BusStopGridHeader>
  );
};
